import React from 'react';
import useMenu from './useMenu';
import MenuDesktop from './desktop';
import MenuMobile from './mobile';

const AppMenu = ({
  variant = 'desktop',
  showMenu,
  onCloseMenu,
  accountMenu,
  workspaceName,
  userFirstName,
}) => {
  const viewModel = useMenu({
    showMenu,
    onCloseMenu,
    accountMenu,
    workspaceName,
    userFirstName,
  });

  if (variant === 'mobile') {
    return <MenuMobile viewModel={viewModel} />;
  }

  return <MenuDesktop viewModel={viewModel} />;
};

export default AppMenu;
